import React from 'react';
import TeamImportViaCSV from 'team/components/leads/importLeads/TeamImportViaCSV';
import TeamLeadDetailsContainer from 'team/components/leads/teamLeadDetails/TeamLeadDetailsContainer';
import TeamLeadsContent from 'team/components/leads/TeamLeadsContent';
import { useLeads } from 'team/hooks/useLeads';

const TeamLeadsContainer = () => {
    const {
        view,
        selectedLead,
        selectedLeadIds,
        searchQuery,
        snackbar,
        filteredLeads,
        isLoadingContacts,
        isRestricted,
        getSelectedLeads,
        handleRefresh,
        handleAddLeads,
        handleExport,
        handleImportCSV,
        handleLeadClick,
        handleBackToList,
        handleSelectLeads,
        handleDateRangeChange,
        handleSearchChange,
        handleSnackbarClose,
        handleDeleteComplete,
        filters,
        filterSearch,
        handleFilterChange,
        handleFilterSearchChange,
        handleClearFilters
    } = useLeads();

    if (view === 'csv-import') {
        return (
            <TeamImportViaCSV />
        );
    }

    if (view === 'lead-details' && selectedLead) {
        return (
            <TeamLeadDetailsContainer
                lead={selectedLead.lead}
                onBack={handleBackToList}
                onDeleteComplete={handleDeleteComplete}
                startInEditMode={selectedLead.startInEditMode}
            />
        );
    }

    return (
        <TeamLeadsContent
            filteredLeads={filteredLeads}
            selectedLeadIds={selectedLeadIds}
            isLoadingContacts={isLoadingContacts}
            snackbar={snackbar}
            onRefresh={handleRefresh}
            onAddLeads={handleAddLeads}
            onExport={handleExport}
            onLeadClick={handleLeadClick}
            onSelectLeads={handleSelectLeads}
            onDateRangeChange={handleDateRangeChange}
            searchQuery={searchQuery}
            onSearchChange={handleSearchChange}
            onImportCSV={handleImportCSV}
            isExportRestricted={isRestricted('Downloading leads (CSV)')}
            isCrmExportRestricted={isRestricted('Exporting Leads to CRM')}
            onSnackbarClose={handleSnackbarClose}
            getSelectedLeads={getSelectedLeads}
            filters={filters}
            filterSearch={filterSearch}
            onFilterChange={handleFilterChange}
            onFilterSearchChange={handleFilterSearchChange}
            onClearFilters={handleClearFilters}
        />
    );
};

export default TeamLeadsContainer;